import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { FilerInformationService } from "../services";
import { map } from "rxjs/operators";

export const OnlyCandidateUserGuard: CanActivateFn = () => {
    const toHome = inject(Router).createUrlTree(["/"]);
    const filer = inject(FilerInformationService);

    return filer.current$.pipe(map((it) => it?.candidateCheck ?? toHome));
}
